import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoQuestionMark = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>QuestionMark</title>
    <circle
      cx={16.993}
      cy={16.997}
      r={12.722}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.997 11.902C13.514 10.441 14.698 9 16.939 9s4.058 1.713 4.058 3.825c0 2.113-1.814 3.983-4.058 4.691v2.818"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path stroke="currentColor" strokeWidth={2.5} strokeLinejoin="round" d="M16.995 24.998h.01v.01h-.01z" />
  </svg>
);
export default SvgIcoQuestionMark;
